export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6694.bb25d53a.jpg";